export const phone = '320px';
export const tablet = '768px';
export const laptop = '1024px';
export const xs = '767px';
